import { QueryClient } from '@tanstack/react-query';

/**
 * Server state for the admin.
 *
 * A module singleton rather than a per-render client, because sign-out has to be
 * able to clear it from outside the React tree. `ADMIN-06`'s DataGrid is what will
 * actually put data in it; it exists now because a sign-out that leaves the previous
 * account's rows in a cache is a data leak between operators on a shared machine,
 * and that has to be true from the first screen rather than retrofitted.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // An admin sitting on a desktop is not a phone on a train: a stale table is
      // worse than a refetch, and the network is not the constraint.
      staleTime: 10_000,
      retry: 1,
    },
    mutations: {
      // A write is not safe to repeat without knowing whether it landed.
      retry: 0,
    },
  },
});
